module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/users/shared/user-list/user-list.component.scss
// module id = ./src/app/users/shared/user-list/user-list.component.scss
// module chunks = main